import { Movement } from 'types';

import { createMovement } from 'modules/transactions/utils/createMovement';
import movementTypes from 'modules/transactions/constants/movementTypes';

import { CustomRange } from '../types/CustomRange';

export const getMovements = (editedRanges: CustomRange[]) => {
  const reclassificationMovements = editedRanges.map(
    (range: CustomRange) =>
      createMovement({
        range,
        movementType: movementTypes.RECLASSIFICATION,
        newFrom: range.newFrom,
        newTo: range.newTo,
        newShareClass: range.selectedShareClassOption?.value || '',
      }) as Movement
  );

  return reclassificationMovements;
};
